import React, { useEffect, useRef } from "react";

function SelectAll({ checked, indeterminate, disabled, onChange, label }) {
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = Boolean(indeterminate);
    }
  }, [indeterminate]);

  return (
    <div className="flex items-center px-3 py-2 border-b border-gray-200">
      <input
        ref={checkboxRef}
        type="checkbox"
        className="w-4 h-4 mr-2 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        checked={Boolean(checked)}
        disabled={Boolean(disabled)}
        onChange={onChange}
      />
      <span className="text-sm text-gray-700">{label || "Select All"}</span>
    </div>
  );
}

export default SelectAll;
